import React from 'react';
import { Col, Label, FormGroup, Row } from '../../../../components/Bootstrap';
import { Switch } from '../../../../components';
import { MenuOption, MenuOptionGroup } from '../../types';
import { OptionsListEditorAddButton } from './OptionsListEditorAddButton';
import { OptionsListEditorRow } from './OptionsListEditorRow';

interface OptionsListEditorProps {
  optionGroup: MenuOptionGroup;
  disabled: boolean;
  isPOSItem: boolean;
  updateOption({
    optionGroupId,
    oldOption,
    newOption,
  }: {
    optionGroupId: string;
    oldOption: MenuOption;
    newOption: MenuOption;
  });
  deleteOption({ optionGroupId, option }: { optionGroupId: string; option: MenuOption });
  onToggleDisabled(optionGroupId);
  onClickAdd();
}

interface OptionsListEditorState {
  isAdding: boolean;
}

export class OptionsListEditor extends React.Component<OptionsListEditorProps, OptionsListEditorState> {
  handleClickAdd = (e) => {
    e.preventDefault();
    this.props.onClickAdd();
  };

  handleCancelAdd = () => {
    this.setState({ isAdding: false });
  };

  handleDelete = (option) => {
    this.props.deleteOption({
      optionGroupId: this.props.optionGroup.id,
      option,
    });
  };

  handleNameChange = (option: MenuOption, name) => {
    this.props.updateOption({
      optionGroupId: this.props.optionGroup.id,
      oldOption: option,
      newOption: {
        ...option,
        option: {
          ...option.option,
          name,
        },
      },
    });
  };

  handlePriceChange = (option: MenuOption, price) => {
    this.props.updateOption({
      optionGroupId: this.props.optionGroup.id,
      oldOption: option,
      newOption: {
        ...option,
        price,
      },
    });
  };

  handleToggle = () => {
    this.props.onToggleDisabled(this.props.optionGroup.id);
  };

  renderRow = (option, index) => {
    const disabledRows = this.props.optionGroup.editorConfig.disabledRows || [];
    const disabled = disabledRows.includes(index);

    return (
      <OptionsListEditorRow
        key={index}
        disabled={disabled}
        onChangeName={this.handleNameChange}
        onChangePrice={this.handlePriceChange}
        onDelete={this.handleDelete}
        option={option}
        index={index}
        isPOSItem={this.props.isPOSItem}
      />
    );
  };

  renderContent() {
    const { optionGroup } = this.props;
    const config = this.props.optionGroup.editorConfig;

    return (
      <div>
        {optionGroup.menuOptions.length > 0 && (
          <Row>
            <Col xs={5}>
              <FormGroup className='mb-0'>
                <Label>{optionGroup.name}</Label>
              </FormGroup>
            </Col>
            <Col>
              <FormGroup className='mb-0'>
                <Label className='ms-3'>Added Cost</Label>
              </FormGroup>
            </Col>
          </Row>
        )}
        <div className='mb-3'>{optionGroup.menuOptions.map(this.renderRow)}</div>
        <OptionsListEditorAddButton
          onClickAdd={this.handleClickAdd}
          text={config.addText ?? `Add ${optionGroup.name}`}
        />
      </div>
    );
  }

  renderSwitchRow = () => {
    const config = this.props.optionGroup.editorConfig;

    if (config.canTurnOff) {
      return (
        <div className='mb-4'>
          <FormGroup className='mb-0'>
            <Label>Enable</Label>
          </FormGroup>
          <Switch
            id={this.props.optionGroup.id}
            checked={!this.props.disabled}
            onChange={this.handleToggle}
            size='sm'
          />
        </div>
      );
    }
  };

  render() {
    const { disabled, optionGroup } = this.props;

    return (
      <div>
        <h3 className='drink-editor-heading'>{optionGroup.name}</h3>
        {this.renderSwitchRow()}
        {!disabled && this.renderContent()}
      </div>
    );
  }
}
